export default class VerMas {
    constructor(elemento) {
        this.elemento = elemento;
        this.alternante = elemento.querySelector("[data-toggle-element='alternante']");
        this.alternador = elemento.querySelector("[data-toggle-element='alternador']");
        this.configurar();
    }

    configurar() {
        this.alternante.ariaExpanded = false;
        this.alternador.ariaPressed = false;
        this.alternarVista = this.botonClickCallback();
        this.alternador.addEventListener("click", this.alternarVista);
    }

    botonClickCallback() {
        return () => {
            const estaPresionado = (this.alternador.getAttribute("aria-pressed") === "true");

            this.alternador.setAttribute("aria-pressed", estaPresionado ? "false" : "true");
            this.alternante.setAttribute("aria-expanded", estaPresionado ? "false" : "true");
        };
    }
}